import * as Types from '../constants/actionTypes'
import { API_LISTS, B2C_CUSTOMER_URL, AUTH_SERVICE_URL, B2C_API_LISTS, ADMIN_SERVIE_URL } from '../helper/constant'
import Axios from '../models/Axios';

export const GET_REQUEST_DETAILS = (payload) => async (dispatch) => {
    try {
        const URL = `${B2C_CUSTOMER_URL}${B2C_API_LISTS.REQUEST_DETAIL_URL}/getAllB2cHomeRequest`;
        const response = await Axios.axios.post(URL, payload)
        dispatch({
            type: Types.TRACK_NO_DETAILS_SUCCESS, requestIdList: response.data.data
        });
    } catch (error) {
        return dispatch({ type: Types.TRACK_NO_DETAILS_ERROR, requsetIdError: error.message });
    }
}

export const GET_TRACK_NO_LIST = (payload) => async (dispatch) => {
    try {
        const URL = `${B2C_CUSTOMER_URL}${B2C_API_LISTS.REQUEST_DETAIL_URL}`;
        const response = await Axios.axios.post(URL, payload)
        dispatch({
            type: Types.TRACK_NO_DETAILS_SUCCESS, requestIdList: response.data.data
        });
    } catch (error) {
        return dispatch({ type: Types.TRACK_NO_DETAILS_ERROR, requsetIdError: error.message });
    }
}

export const GET_PORTAL_STAGES_STATUS = (payload) => async (dispatch) => {
    try {
        const URL = `${ADMIN_SERVIE_URL}${API_LISTS.PROGRAM_REQUEST_STAGE_STATUS}/listPortalStatRequestType`
        const response = await Axios.axios.post(URL, payload)
        dispatch({
            type: Types.PORTAL_STATUS_SUCCESS, portalStageStatList: response.data.data
        });
    } catch (error) {
        return dispatch({ type: Types.PORTAL_STATUS_ERROR, portalStageStatError: error.message });
    }
}

export const GET_ASSET_TYPE_LIST = (payload) => async (dispatch) => {
    try {
        const URL = `${B2C_CUSTOMER_URL}${B2C_API_LISTS.B2C_ASSET_TYPE}/getAssetTypeList`;
        const response = await Axios.axios.post(URL, payload)
        dispatch({
            type: Types.ASSET_TYPE_SUCCESS, assetTypeList: response.data.data
        });
    } catch (error) {
        return dispatch({ type: Types.ASSET_TYPE_ERROR, assetTypeError: error.message });
    }
}


export const ADD_RECEPTION_UPDATED_LIST = (payload, finalPayload) => async (dispatch) => {
    try {
        const URL = `${B2C_CUSTOMER_URL}${B2C_API_LISTS.B2C_REQUEST_ASSETS}/createB2CRequest`;
        const response = await Axios.axios.post(URL, payload)
        if (response.status === 200 && finalPayload.newStatusId) {
            const URL = `${ADMIN_SERVIE_URL}${API_LISTS.PROCESSLIST_URL}/approveStatus`
            await Axios.axios.post(URL, finalPayload)
        }
        dispatch({
            type: Types.TRACK_NO_DETAILS_SUCCESS, requestIdList: response.data.data
        });
    } catch (error) {
        return dispatch({ type: Types.TRACK_NO_DETAILS_ERROR, requsetIdError: error.message });
    }
}

export const GET_REQ_DETAILS_BY_RANGE = (payload) => async (dispatch) => {
    try {
        const URL = `${B2C_CUSTOMER_URL}${API_LISTS.PROCESSLIST_URL}/fetchB2CReqDetailsByRange`;
        const response = await Axios.axios.post(URL, payload)
        dispatch({
            type: Types.REQUEST_DETAIL_RANGE_SUCCESS, requestRangeList: response.data
        });
    } catch (error) {
        return dispatch({ type: Types.REQUEST_DETAIL_RANGE_ERROR, requestRangeError: error.message });
    }
}

export const GET_SITEID_REQ_DETAILS_ = (payload) => async (dispatch) => {
    try {
        const URL = `${AUTH_SERVICE_URL}/client/getCollectionBySite`;
        const response = await Axios.axios.post(URL, payload)
        dispatch({
            type: Types.REQUEST_DETAIL_RANGE_SUCCESS, requestRangeList: response.data
        });
    } catch (error) {
        return dispatch({ type: Types.REQUEST_DETAIL_RANGE_ERROR, requestRangeError: error.message });
    }
}

// request report document
export const CREATE_B2C_REPORT_DOC = (fileData, payload) => async (dispatch) => {
    const { userId, programId, reportType, programType } = payload
    try {
        let rType = reportType.replace(" ", "_")
        const URL = `${AUTH_SERVICE_URL}/user/uploadB2CReport`;
        let date = new Date()
        const fullDate = Date.parse(date.toString());
        const fileName = `${rType}_${fullDate}.xlsx`
        const params = {
            userId,
            programId,
            reportType,
            programType,
            fileName
        }
        const userResponse = await Axios.axios.post(URL, { fileData, params }, { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([userResponse.data]))
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    } catch (error) {
    }
}

// get link document by createdBy
export const GET_REPORT_DOC_USERID = (payload) => async (dispatch) => {
    try {
        const URL = `${B2C_CUSTOMER_URL}${B2C_API_LISTS.B2C_REPORTS_DOCS_URL}/fetchRequestDocByUserId`;
        const response = await Axios.axios.post(URL, payload)
        dispatch({
            type: Types.REPORT_DOC_SUCCESS, requestDocList: response.data
        });
    } catch (error) {
        return dispatch({ type: Types.REPORT_DOC_ERROR, requestDocError: error.message });
    }
}

export const DOWNLOAD_REPORT_DOCUMENT = (payload) => async (dispatch) => {
    try {
        const { docName } = payload
        if (!docName) {
            dispatch({
                type: Types.REPORT_DOC_ERROR,
                error: `Please Provide Report Document Information`
            })
        }
        const URL = `${AUTH_SERVICE_URL}/portal/downloadB2CReport`
        const response = await Axios.axios.post(URL, payload, { responseType: 'blob' })
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', docName);
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        dispatch({
            type: Types.REPORT_DOC_ERROR,
            error: error && error.message
        })
    }
}

export const DELETE_B2C_REPORT_DOCUEMENT = (payload) => async (dispatch) => {
    try {
        const { id, docName } = payload
        if (!id || !docName) {
            return dispatch({
                type: Types.REPORT_DOC_ERROR,
                error: `Please provide proper Report Document Information`
            })
        }
        const DEL_URL = `${AUTH_SERVICE_URL}/portal/deleteB2CReport`
        await Axios.axios.post(DEL_URL, payload)
        dispatch({
            type: Types.REPORT_DOC_DELETED, delId: id
        })
    } catch (error) {
        dispatch({
            type: Types.REPORT_DOC_ERROR,
            error: error && error.message
        })
    }
}

